/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseEmailTemplate } from './DatabaseEmailTemplate';
import {
    DatabaseEmailTemplateFromJSON,
    DatabaseEmailTemplateFromJSONTyped,
    DatabaseEmailTemplateToJSON,
} from './DatabaseEmailTemplate';

/**
 * 
 * @export
 * @interface DatabaseEmailTemplateSpecification
 */
export interface DatabaseEmailTemplateSpecification {
    /**
     * 
     * @type {string}
     * @memberof DatabaseEmailTemplateSpecification
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseEmailTemplateSpecification
     */
    name?: string;
    /**
     * 
     * @type {DatabaseEmailTemplate}
     * @memberof DatabaseEmailTemplateSpecification
     */
    template?: DatabaseEmailTemplate;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseEmailTemplateSpecification
     */
    formatted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DatabaseEmailTemplateSpecification
     */
    from?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DatabaseEmailTemplateSpecification
     */
    bcc?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DatabaseEmailTemplateSpecification
     */
    subjectTpl?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseEmailTemplateSpecification
     */
    bodyTpl?: string;
}

/**
 * Check if a given object implements the DatabaseEmailTemplateSpecification interface.
 */
export function instanceOfDatabaseEmailTemplateSpecification(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseEmailTemplateSpecificationFromJSON(json: any): DatabaseEmailTemplateSpecification {
    return DatabaseEmailTemplateSpecificationFromJSONTyped(json, false);
}

export function DatabaseEmailTemplateSpecificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseEmailTemplateSpecification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'template': !exists(json, 'template') ? undefined : DatabaseEmailTemplateFromJSON(json['template']),
        'formatted': !exists(json, 'formatted') ? undefined : json['formatted'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'bcc': !exists(json, 'bcc') ? undefined : json['bcc'],
        'subjectTpl': !exists(json, 'subjectTpl') ? undefined : json['subjectTpl'],
        'bodyTpl': !exists(json, 'bodyTpl') ? undefined : json['bodyTpl'],
    };
}

export function DatabaseEmailTemplateSpecificationToJSON(value?: DatabaseEmailTemplateSpecification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'template': DatabaseEmailTemplateToJSON(value.template),
        'formatted': value.formatted,
        'from': value.from,
        'bcc': value.bcc,
        'subjectTpl': value.subjectTpl,
        'bodyTpl': value.bodyTpl,
    };
}

